import * as React from "react";
import type { SVGProps } from "react";
const SvgLogoStripe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 81 48"
    {...props}
  >
    <g
      fill="#635BFF"
      clipPath="url(#Logo_Stripe_svg__a)"
    >
      <path
        fillRule="evenodd"
        d="M79.92 25.816c0-5.64-2.731-10.089-7.952-10.089-5.243 0-8.415 4.45-8.415 10.045 0 6.631 3.745 9.98 9.12 9.98 2.621 0 4.604-.595 6.102-1.432v-4.406c-1.498.749-3.216 1.211-5.397 1.211-2.137 0-4.031-.748-4.274-3.348h10.773c0-.286.044-1.432.044-1.96m-10.882-2.092c0-2.49 1.52-3.525 2.908-3.525 1.344 0 2.776 1.035 2.776 3.525zM55.05 15.727c-2.16 0-3.547 1.013-4.318 1.718l-.287-1.366H45.6v25.687l5.507-1.168.022-6.234c.793.573 1.96 1.388 3.9 1.388 3.943 0 7.533-3.173 7.533-10.156-.022-6.388-3.657-9.87-7.512-9.87m-1.322 15.178c-1.3 0-2.071-.463-2.6-1.035l-.022-8.173c.573-.639 1.366-1.08 2.622-1.08 2.004 0 3.392 2.247 3.392 5.133 0 2.952-1.366 5.155-3.392 5.155M38.02 14.427l5.53-1.19V8.767l-5.53 1.167z"
        clipRule="evenodd"
      />
      <path d="M43.55 16.101h-5.53v19.276h5.53z" />
      <path
        fillRule="evenodd"
        d="m32.094 17.732-.352-1.63h-4.758v19.275h5.507V22.314c1.3-1.697 3.503-1.388 4.186-1.146v-5.067c-.705-.264-3.283-.749-4.583 1.63M21.08 11.321l-5.375 1.146-.022 17.645c0 3.26 2.445 5.662 5.705 5.662 1.807 0 3.129-.33 3.855-.727v-4.472c-.704.286-4.185 1.3-4.185-1.961v-7.82h4.186V16.1h-4.186zM6.188 21.697c0-.86.705-1.19 1.873-1.19 1.674 0 3.789.507 5.463 1.41V16.74c-1.828-.727-3.635-1.013-5.463-1.013-4.472 0-7.446 2.335-7.446 6.234 0 6.08 8.371 5.111 8.371 7.733 0 1.013-.881 1.343-2.115 1.343-1.828 0-4.163-.749-6.014-1.762v5.243a15.3 15.3 0 0 0 6.014 1.256c4.582 0 7.733-2.27 7.733-6.213-.022-6.564-8.416-5.397-8.416-7.864"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="Logo_Stripe_svg__a">
        <path
          fill="#fff"
          d="M.615 0h80v48h-80z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoStripe;
